module.exports = __webpack_public_path__ + "img/dots.a037f2f7.svg";